import { render, staticRenderFns } from "./Icat01.vue?vue&type=template&id=a134b4ae&"
import script from "./Icat01.vue?vue&type=script&lang=js&"
export * from "./Icat01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports